import Screen from "../../utils/Screen";

const COLORS = ["blue", "grey", "pink", "grey", "green", "grey"];
const COLOR_PREFIX = "c-marquee-btn__item--";

export default class MarqueeBtn {
  constructor(el) {
    this.el = el;
    this.tracks = [...el.querySelectorAll(".c-marquee-btn__track")];

    this._resizeHandler = this.onResize.bind(this);

    // Line 1 keeps the authored order; the reverse track gets its items
    // shuffled once, before cloning / colour assignment happens.
    const reverseSet = el.querySelector(
      ".c-marquee-btn__track--reverse .c-marquee-btn__set"
    );
    if (reverseSet) {
      const items = [...reverseSet.children];
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
      }
      items.forEach((item) => reverseSet.appendChild(item));
    }

    // Wait one frame so layout is computed before measuring
    requestAnimationFrame(() => {
      this.tracks.forEach((track) => this.init(track));
      this._lastWidth = Screen.width;
      Screen.onResize(this._resizeHandler);
    });
  }

  init(track) {
    const PIXELS_PER_SECOND = 40;

    // Remove cloned sets from previous build
    track.querySelectorAll("[data-clone]").forEach((el) => el.remove());

    const originalSet = track.querySelector(".c-marquee-btn__set");
    if (!originalSet) return;

    const trackGap = parseFloat(getComputedStyle(track).gap) || 0;
    const setWidth = originalSet.offsetWidth + trackGap;
    if (setWidth <= 0) return;

    // Even number of sets so -50% lands exactly on a set boundary
    const minSets = Math.max(2, Math.ceil((2 * Screen.width) / setWidth));
    const totalSets = minSets % 2 === 0 ? minSets : minSets + 1;
    const clonesNeeded = totalSets - 1;

    for (let i = 0; i < clonesNeeded; i++) {
      const clone = originalSet.cloneNode(true);
      clone.setAttribute("data-clone", "");
      track.appendChild(clone);
    }

    // Assign colors based on position within the set so every duplicate set is identical
    const itemsPerSet = originalSet.querySelectorAll(".c-marquee-btn__item").length;
    const allItems = [...track.querySelectorAll(".c-marquee-btn__item")];
    allItems.forEach((item, i) => {
      COLORS.forEach((c) => item.classList.remove(COLOR_PREFIX + c));
      item.classList.add(COLOR_PREFIX + (item.dataset.color ?? COLORS[(i % itemsPerSet) % COLORS.length]));
    });

    const loopDistance = (totalSets / 2) * setWidth;
    const duration = loopDistance / PIXELS_PER_SECOND;
    track.style.setProperty("--marquee-distance", `${loopDistance.toFixed(2)}px`);
    track.style.setProperty("--marquee-duration", `${duration.toFixed(2)}s`);
  }

  // Width only: the set count and loop distance depend on it, not on the height.
  // Height-only resizes fire all the time on mobile (URL bar showing / hiding
  // while scrolling) and rebuilding there re-cloned the DOM and restarted the
  // animation mid-scroll.
  onResize(width) {
    if (width === this._lastWidth) return;
    this._lastWidth = width;
    this.tracks.forEach((track) => this.init(track));
  }
}
